import { MinervaRouteProps, NavigationRoutes } from './navigation.types'

export const filterNavigationRoutes = (routes: NavigationRoutes): [route: string, routeDetails: MinervaRouteProps][] =>
  Object.entries(routes).filter(([_, routeDetails]) => routeDetails.showInNav)
